/**
 * File: form-toolkit.js
 *
 * Import and initialize functions for the To Top button accessibility
 */

export default {
  scrollToTop: document.querySelector('.trx_addons_scroll_to_top'),
  init() {
    if (this.scrollToTop) {
      this.render();
    }
  },
  render() {
    const skipToContent = document.querySelector('#pojo-a11y-skip-content');
    this.scrollToTop.addEventListener('click', () => {
      skipToContent.focus();
    });
  },
};
